import React from "react";
import './style.css';

const ToggleIcon = ({ dark, setDark }) => {
    return <div className={`toggleIcons ${dark ? 'day-toggle' : 'dark-toggle'}`} onClick={e => setDark(!dark)}>
        <span className={`fa ${dark ? 'fa-sun-o' : 'fa-moon-o'}`}></span>
    </div>
};

export default ToggleIcon;